import React from 'react';
import { Drawer, Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import CustomerProducts from '../../customers/elements/customerProducts/CustomerProducts';

interface CustomerProductsDrawerProps {
  isDrawerOpen: boolean;
  closeDrawerCallback: (open: boolean) => void;
  customerId: number;
  customerName: string;
  drawerTitle: string;
}

const CustomerProductsDrawer: React.FC<CustomerProductsDrawerProps> = ({
  isDrawerOpen,
  closeDrawerCallback,
  customerId,
  customerName,
  drawerTitle
}) => {
  const handleClose = () => {
    closeDrawerCallback(false);
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={handleClose}
      PaperProps={{
        sx: { width: 500 }
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">{drawerTitle}</Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
        
        <CustomerProducts 
          customerId={customerId}
          customerName={customerName}
        />
      </Box>
    </Drawer>
  );
};

export default CustomerProductsDrawer;